var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { camelCase } from 'lodash';
var HttpException = (function (_super) {
    __extends(HttpException, _super);
    function HttpException(message, originalException) {
        var _this = _super.call(this, message) || this;
        _this.originalException = originalException;
        return _this;
    }
    return HttpException;
}(Error));
export { HttpException };
var ValidationException = (function (_super) {
    __extends(ValidationException, _super);
    function ValidationException(validationErrors, originalException) {
        var _this = _super.call(this, 'Validation failed', originalException) || this;
        _this.validationErrors = validationErrors || [];
        return _this;
    }
    return ValidationException;
}(HttpException));
export { ValidationException };
export var getErrors = function (validationErrors) {
    return validationErrors.reduce(function (previous, current) {
        var _a;
        return (__assign(__assign({}, previous), (_a = {}, _a[current.Field.split('.').map(camelCase).join('.')] = __spreadArray(__spreadArray([], (previous[current.Field] || []), true), [
            current.ErrorCode,
        ], false), _a)));
    }, {});
};
var InternalServerError = (function (_super) {
    __extends(InternalServerError, _super);
    function InternalServerError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InternalServerError;
}(HttpException));
export { InternalServerError };
//# sourceMappingURL=exceptions.js.map